export default function csvToJson(csvData) {
    const rows = csvData.split('\n');
    const headers = rows[0].split(',');

    const data = [];

    for (let i = 1; i < rows.length; i++) {
        const values = rows[i].split(',');
        const rowObject = {};

        for (let j = 0; j < headers.length; j++) {
            const header = headers[j].trim();
            let value = values[j].trim();

            // Check if the value is a number
            if (!isNaN(value.replace(/[,]/g, ''))) {
                value = parseFloat(value.replace(/[,]/g, ''));
            }

            rowObject[header] = value;
        }

        data.push(rowObject);
    }

    return data;
}

export  function calculateRapDis(value,disc) {
    return value - (disc / 100) * value
}
export  function calculateRateToDisc(rap,price) {
    return 100 -((price * 100)/rap)
}
